import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { I18nProvider } from './lib/i18n';
import { AuthCallback } from './components/AuthCallback';
import { SetupFlow } from './components/SetupFlow';
import { Layout } from './components/Layout';
import { BrainDump } from './components/BrainDump';
import { AlgoAnalyzer } from './components/AlgoAnalyzer';
import { ComposeIdeas } from './components/ComposeIdeas';
import { ContentCoach } from './components/ContentCoach';
import { History } from './components/History';
import { Inspiration } from './components/Inspiration';
import { Education } from './components/Education';
import { AccountResearcher } from './components/AccountResearcher';
import { ReplyGuy } from './components/ReplyGuy';
import { AdminPanel } from './components/AdminPanel';
import { Drafts } from './components/Drafts';
import { Analytics } from './components/Analytics';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './components/Toast';
import { storageService } from './services/storageService';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './components/LoginPage';
import { TwitterLogin } from './components/TwitterLogin';


function App() {
  // 初回ロード時にマイグレーション実行 + X APIメトリクス自動更新
  useEffect(() => {
    storageService.initializeStorage();

    // X API credentials があれば、投稿済みツイートのメトリクスを自動取得
    import('./services/xApiService').then(({ xApiService }) => {
      if (xApiService.hasCredentials() && xApiService.getPostedTweets().length > 0) {
        xApiService.refreshMetrics().catch(() => {/* silent */});
      }
    });
  }, []);

  // セットアップ不要 — 直接アプリに入れる
  const isSetupComplete = () => true;

  return (
    <I18nProvider>
    <ToastProvider>
    <AuthProvider>
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<TwitterLogin />} />
          <Route path="/app" element={
            isSetupComplete() ? <Navigate to="/brain-dump" /> : <Navigate to="/setup" />
          } />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/setup" element={<ProtectedRoute><SetupFlow /></ProtectedRoute>} />

          {/* Main App Routes */}
          <Route path="/brain-dump" element={<ProtectedRoute><Layout><BrainDump /></Layout></ProtectedRoute>} />
          <Route path="/compose" element={<ProtectedRoute><Layout><ComposeIdeas /></Layout></ProtectedRoute>} />
          <Route path="/coach" element={<ProtectedRoute><Layout><ContentCoach /></Layout></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><Layout><History /></Layout></ProtectedRoute>} />
          <Route path="/inspiration" element={<ProtectedRoute><Layout><Inspiration /></Layout></ProtectedRoute>} />
          <Route path="/education" element={<ProtectedRoute><Layout><Education /></Layout></ProtectedRoute>} />
          <Route path="/researcher" element={<ProtectedRoute><Layout><AccountResearcher /></Layout></ProtectedRoute>} />
          <Route path="/reply" element={<ProtectedRoute><Layout><ReplyGuy /></Layout></ProtectedRoute>} />
          <Route path="/algo" element={<ProtectedRoute><Layout><AlgoAnalyzer /></Layout></ProtectedRoute>} />
          <Route path="/drafts" element={<ProtectedRoute><Layout><Drafts /></Layout></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><Layout><Analytics /></Layout></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Layout><AdminPanel /></Layout></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </ErrorBoundary>
    </AuthProvider>
    </ToastProvider>
    </I18nProvider>
  );
}


export default App;
